import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.97607 21.5066H2.00342V14.0662L7.97607 8.48999V21.5066ZM21.9595 21.5066H15.9927V8.94312L21.9595 2.01636V21.5066ZM17.9927 9.68628V19.5066H19.9595V7.4021L17.9927 9.68628ZM4.00342 14.9353V19.5066H5.97607V13.0935L4.00342 14.9353ZM9.04346 2.03491L15.9438 8.93921L12.146 12.7371L1.99756 2.03491H9.04346ZM12.1831 9.86987L13.1147 8.93823L8.21533 4.03491H6.65088L12.1831 9.86987Z"}}]};

const LogoXiaomareport = Vue.extend<IconProps>({
  name: 'LogoXiaomareportIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-xiaomareport',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoXiaomareport;
